import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  padding: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  margin-top: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const TopHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  min-height: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    padding: 0.125rem 0 0.125rem 0;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const MainTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.interfaceText400};
  margin: 0;
  line-height: 1.1;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1.25rem;
  border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primaryRed400};
  color: ${({ theme }) => theme.colors.pureWhite};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;

  svg {
    min-width: 19px;
    min-height: 19px;
    width: 19px;
    height: 19px;
    flex-shrink: 0;
  }

  &.disabled,
  &:disabled {
    background: ${({theme}) => theme.colors.disabledBg};
    border-color: ${({theme}) => theme.colors.disabledBg};
    color: ${({theme}) => theme.colors.disabledText};
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 1000px) {
    flex-shrink: 0;
    min-width: fit-content;
    
    svg {
      min-width: 19px;
      min-height: 19px;
      width: 19px;
      height: 19px;
      flex-shrink: 0;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1rem;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.interfaceText400};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  svg {
    width: 1.54em;
    height: 1.54em;
    flex-shrink: 0;
    
    path {
      fill: ${(props: any) => props.theme.colors.c999999};
    }
  }

  &:disabled {
    background: ${({theme}) => theme.colors.disabledBg};
    border-color: ${({theme}) => theme.colors.disabledBg};
    color: ${({theme}) => theme.colors.disabledText};
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const RelatorioButton = styled(ActionButton)`
  svg {
    path {
      fill: none;
      stroke: ${(props: any) => props.theme.colors.c999999};
    }
  }

  &.disabled,
  &:disabled {
    background: ${({theme}) => theme.colors.disabledBg};
    border-color: ${({theme}) => theme.colors.disabledBg};
    color: ${({theme}) => theme.colors.disabledText};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const BadgeCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  min-width: 16px;
  line-height: 18px;
  padding: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: ${({ theme }) => theme.colors.interfaceGray300};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border-radius: 4px;
  margin-left: 0.5rem;
  text-align: center;
`;
